import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import type {
  GalleryCounts,
  GalleryListFilter,
  GalleryListResponse,
  GalleryUploadPayload,
} from '@/features/gallery/types/gallery';

export async function fetchGalleryList(filter: GalleryListFilter) {
  const { data } = await httpClient.get(endpoints.gallery.list, {
    params: filter,
  });
  return data as GalleryListResponse;
}

export async function fetchGalleryCounts() {
  const { data } = await httpClient.get(endpoints.gallery.counts);
  return data as {
    success?: boolean;
    message?: string;
    data?: GalleryCounts;
  };
}

export async function uploadGalleryItem(payload: GalleryUploadPayload) {
  const { data } = await httpClient.post(endpoints.gallery.upload, payload);
  return data as { success?: boolean; message?: string };
}

export async function deleteGalleryItem(galleryId: string) {
  const { data } = await httpClient.delete(endpoints.gallery.delete, {
    params: { galleryId },
  });
  return data as { success?: boolean; message?: string };
}
